import { Acknowledgement, AcknowledgementHistory } from '../models/acknowledgement';
import { IApiService, IPaginatedResponse } from '../services/api_service';

export const acknowledgement = (centralApi: IApiService) => ({
  index: (params = ({} = null)): Promise<IPaginatedResponse<Acknowledgement>> => {
    return centralApi.get<IPaginatedResponse<Acknowledgement>>('/acknowledgement', {
      params
    });
  },
  history: {
    index: (params = ({} = null)): Promise<IPaginatedResponse<AcknowledgementHistory>> => {
      return centralApi.get<IPaginatedResponse<AcknowledgementHistory>>('/acknowledgement/history', {
        params
      });
    }
  }
});
